export const RoundedCheckboxIndeterminate = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="1"
      y="1"
      width="18"
      height="18"
      rx="4"
      ry="4"
      stroke="rgba(157, 78, 221, 1)"
      strokeWidth="1.5"
      fill="rgba(157, 78, 221, 1)"
    />
    <rect x="5" y="8.5" width="10" height="3" rx="1.5" fill="white" />
  </svg>
);
